module.exports = __webpack_public_path__ + "img/35.0af1a6b1.svg";